module.exports = "/_next/static/images/ChatbotsDoughnut-83d3eebed2a3048d351d992d382589c2.png";